import { types } from "@/actions/map/select/manual/move";

const initialState = {
    moveDistanceNumber: 1,
};

/**
 * Reducer for the manual move distance configuration.
 *
 * @param state - The current move state.
 * @param root0 - The dispatched action.
 * @param root0.payload - The action payload.
 * @param root0.type - The action type.
 * @returns The next move state.
 */
export default (state = initialState, { payload, type }) => {
    switch (type) {
        case types.CHANGE_DISTANCE_NUMBER:
            return { ...state, moveDistanceNumber: payload };
        default:
            return state;
    }
};
